$(function () {
  $(document).on('focus', '.skip-to-content', function () {
    $(this).addClass('hc-focused');
  });

  $(document).on('blur', '.skip-to-content', function () {
    $(this).removeClass('hc-focused');
  });

  $(document).on('click', '.skip-to-content', function (e) {
    e.preventDefault();
    var targetId = $(this).attr('href').substring(1);
    var $target = $('#' + targetId);
    if ($target.length) {
      $target.attr('tabindex', '-1');
      $target[0].scrollIntoView({ behavior: 'instant', block: 'start' });
      setTimeout(function () {
        $target[0].focus({ preventScroll: true });
      }, 50);
    }
  });
});

document.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter') return;

  const active = document.activeElement;
  const isFocusableList =
    (['LI', 'DIV', 'SELECTOR'].includes(active.tagName)) &&
    active.getAttribute('role') === 'list';

  if (!isFocusableList) return;

  const clickable = active.querySelector('a.js-drawer-open-right-link, button');
  if (!clickable) return;

  e.preventDefault();
  clickable.focus();

  // Prevent anchor navigation
  const preventNav = ev => {
    ev.preventDefault();
    clickable.removeEventListener('click', preventNav);
  };
  clickable.addEventListener('click', preventNav);

  clickable.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));

  const body = document.body;
  const drawer = document.querySelector('#CartDrawer');

  if (!drawer) return;

  // Step 1: Wait for body to get js-drawer-open
  const waitForDrawerAndFocus = () => {
    if (!body.classList.contains('js-drawer-open')) return;

    // Step 2: Once open, observe #CartDrawer for first interactive content
    const contentObserver = new MutationObserver(() => {
      const focusable = drawer.querySelector(
        'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (focusable) {
        focusable.focus();
        contentObserver.disconnect();
        classObserver.disconnect();
      }
    });

    contentObserver.observe(drawer, { childList: true, subtree: true });
  };

  // Listen for body class change
  const classObserver = new MutationObserver(waitForDrawerAndFocus);
  classObserver.observe(body, { attributes: true, attributeFilter: ['class'] });

  // Also call once in case class already present
  setTimeout(waitForDrawerAndFocus, 50);
});